import { createStore } from 'vuex';
import cart from './modules/cart';

export const store = createStore({
    modules: {
        cart,
    },
});
